import { createFileRoute } from "@tanstack/react-router";

/** Post-admission routing is owned by the protected-route access registry. */
export const Route = createFileRoute("/_protected/dashboard/")({});
